export default "__VITE_ASSET__LB37dDwP__"